<div class="review-dialog-container">
  <div class="dialog-header">
    <h2>
      <i class="fa-solid fa-star-half-stroke"></i>
      Share Your Experience
    </h2>
    <div class="spacer"></div>
    <button class="btn-cancel" (click)="close()">Cancel</button>
    <button class="btn-submit" (click)="submit()">
      {{ data?.existingReview ? "Update Review" : "Submit Review" }}
    </button>
  </div>

  <div class="dialog-content">
    <!-- MODE: CUSTOMER RATING VENDOR/EQUIPMENT -->
    <ng-container *ngIf="!data.isVendorMode">
      <!-- SECTION 1: EQUIPMENT -->
      <div class="review-card" *ngIf="!data.isRejected">
        <div class="card-header">
          <mat-icon>engineering</mat-icon>
          <h3>Equipment Review</h3>
        </div>
        
        <div class="rating-box">
          <p>How was the equipment condition?</p>
          <div class="stars">
            <mat-icon 
              *ngFor="let s of [1,2,3,4,5]" 
              [class.filled]="equipmentRating >= s"
              (click)="equipmentRating = s">
              {{ equipmentRating >= s ? 'star' : 'star_border' }}
            </mat-icon>
          </div>
        </div>

        <div class="questions-list">
          <div class="question-row" *ngFor="let q of equipmentQuestions">
            <p class="q-label">{{ q.label }}</p>
            <div class="q-stars">
              <mat-icon 
                *ngFor="let s of [1,2,3,4,5]" 
                [class.filled]="q.answer >= s"
                (click)="q.answer = s">
                {{ q.answer >= s ? 'star' : 'star_border' }}
              </mat-icon>
            </div>
          </div>
        </div>

        <div class="comment-box">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>What did you think of the equipment?</mat-label>
            <textarea matInput [(ngModel)]="equipmentFinalReview" rows="3" placeholder="Tell us more..."></textarea>
          </mat-form-field>
        </div>
      </div>

      <!-- SECTION 2: VENDOR -->
      <div class="review-card">
        <div class="card-header">
          <mat-icon>store</mat-icon>
          <h3>Vendor Review</h3>
        </div>

        <div class="rating-box">
          <p>How was the service provided by the vendor?</p>
          <div class="stars">
            <mat-icon 
              *ngFor="let s of [1,2,3,4,5]" 
              [class.filled]="vendorRating >= s"
              (click)="vendorRating = s">
              {{ vendorRating >= s ? 'star' : 'star_border' }}
            </mat-icon>
          </div>
        </div>

        <div class="questions-list">
          <div class="question-row" *ngFor="let q of vendorQuestions">
            <p class="q-label">{{ q.label }}</p>
            <div class="q-stars">
              <mat-icon 
                *ngFor="let s of [1,2,3,4,5]" 
                [class.filled]="q.answer >= s"
                (click)="q.answer = s">
                {{ q.answer >= s ? 'star' : 'star_border' }}
              </mat-icon>
            </div>
          </div>
        </div>

        <div class="comment-box">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>What did you think of the vendor's service?</mat-label>
            <textarea matInput [(ngModel)]="vendorFinalReview" rows="3" placeholder="Tell us more..."></textarea>
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <!-- MODE: VENDOR RATING CUSTOMER -->
    <ng-container *ngIf="data.isVendorMode">
      <div class="review-card">
        <div class="card-header">
          <mat-icon>person</mat-icon>
          <h3>Customer Review</h3>
        </div>

        <div class="rating-box">
          <p>How was your overall experience with this customer?</p>
          <div class="stars">
            <mat-icon 
              *ngFor="let s of [1,2,3,4,5]" 
              [class.filled]="customerRating >= s"
              (click)="customerRating = s">
              {{ customerRating >= s ? 'star' : 'star_border' }}
            </mat-icon>
          </div>
        </div>

        <div class="questions-list">
          <div class="question-row" *ngFor="let q of customerQuestions">
            <p class="q-label">{{ q.label }}</p>
            <div class="q-stars">
              <mat-icon 
                *ngFor="let s of [1,2,3,4,5]" 
                [class.filled]="q.answer >= s"
                (click)="setQuestionRating(q, s)">
                {{ q.answer >= s ? 'star' : 'star_border' }}
              </mat-icon>
            </div>
          </div>
        </div>

        <div class="comment-box">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>What did you think of the customer?</mat-label>
            <textarea matInput [(ngModel)]="customerFinalReview" rows="3" placeholder="Tell us more..."></textarea>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </div>
</div>
